<template>
  <div class="home">
      <Android v-if="platformQuery === 'android' || platformQuery === 'pc'" />
      <IOS v-if="platformQuery === 'ios'"/>
  </div>
</template>

<script>
import Android from './android'
import IOS from './ios'
import Platform from '../platform'

export default {
  name: 'home',
  components: {
    Android,
    IOS
  },
  data () {
    return {
      platformQuery: 'pc',
      Platform
    }
  },
  mounted () {
    let platform = this.$route.query.platform
    if (platform) {
      this.platformQuery = platform
    } else if (Platform.isIos) {
      this.platformQuery = 'ios'
    } else if (Platform.isAndroid) {
      this.platformQuery = 'android'
    }

    // console.log(platform)
    // console.log(Platform.isIos)
    // console.log(Platform.isAndroid)
    // console.log(this.platformQuery)
  }
}

</script>
<style lang="scss" scoped>
.home{
  position: relative;
}
</style>
